// withErrorBoundary.tsx
import * as React from 'react'
import { ErrorBoundary } from '@/modules/shared/components/ErrorBoundary'
import { ErrorFallback } from '@/modules/shared/components/ErrorFallback'

/**
 * HOC that wraps the component with ErrorBoundary.
 * Allows supplying a custom fallback component.
 */
export function withErrorBoundary<P>(
  Wrapped: React.ComponentType<P>,
  options?: {
    fallback?: (args: { error: unknown; reset: () => void }) => React.ReactNode
  }
) {
  const ComponentWithBoundary = (props: P) => (
    <ErrorBoundary
      fallback={(e) =>
        options?.fallback
          ? options.fallback(e)
          : <ErrorFallback error={e.error} onRetry={e.reset} />
      }
    >
      <Wrapped {...props} />
    </ErrorBoundary>
  )

  ComponentWithBoundary.displayName =
    `withErrorBoundary(${Wrapped.displayName || Wrapped.name || 'Component'})`

  return ComponentWithBoundary
}
